import {ajax, getRequestUrl, formatData, uploadImg} from "./request";
// 房间专栏



// 房间专栏 -- 房间banner列表（好多bug，对一半先弄别的模块）
function roomBannerListByPage(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerListByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 房间专栏 --上下架房间
function roomBannerIsOn(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerIsOn'), data, {
    method,
  });
}

// 房间专栏 --删除房间banner
function roomBannerDelete(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerDelete'), data, {
    method,
  });
}

// 房间专栏 --房间banner详情
function roomBannerInfo(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerInfo'), data, {
    method,
  });
}


// 房间专栏 -- 保存/新增房间banner
function roomBannerSave(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerSave'), data, {
    method,
  });
}

// 房间专栏 -- banner申请列表
function roomBannerApplicationList(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 房间专栏 -- banner 申请 -- 删除申请数据
function roomBannerApplicationDelete(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationDelete'), data, {
    method,
  });
}

// 房间专栏 -- banner 申请 -- 申请详情
function roomBannerApplicationInfo(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationInfo'), data, {
    method,
  });
}

// 房间专栏 -- banner 申请 -- 保存房间banner申请
function roomBannerApplicationSave(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationSave'), data, {
    method,
  });
}

// 房间专栏 -- banner 申请 -- 审核banner申请
function roomBannerApplicationCheck(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationCheck'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 列表
function hurdleList(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleList'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 保存
function hurdleSave(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleSave'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 专栏房间列表
function hurdleRoomList(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomList'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 新增房间
function hurdleRoomSave(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomSave'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 删除房间房间
function hurdleRoomDelete(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomDelete'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 上下架时间
function room_hurdleOn(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleOn'), data, {
    method,
  });
}

// 房间专栏 -- 发现页banner] 批量删除
function hurdleDelete(data, method) {
  return ajax('post', getRequestUrl('/api/RoomTopic/hurdleDelete'), data, {
    method,
  });
}
// 上传文件
function uploadRoomsExcel(data) {
  return uploadImg(getRequestUrl('/api/RoomTopic/uploadRoomsExcel'), data)
}



export default {
  uploadRoomsExcel,
  hurdleDelete,
  room_hurdleOn,
  roomBannerListByPage,
  roomBannerIsOn,
  roomBannerDelete,
  roomBannerInfo,
  roomBannerSave,

  roomBannerApplicationList,
  roomBannerApplicationDelete,
  roomBannerApplicationInfo,
  roomBannerApplicationSave,
  roomBannerApplicationCheck,
  hurdleList,
  hurdleSave,
  hurdleRoomList,
  hurdleRoomSave,
  hurdleRoomDelete

}



// WEBPACK FOOTER //
// ./src/js/roomColumn.js